import {
  SiteNotificationAddedSubscription,
  SiteNotificationAddedSubscriptionDocument,
  SiteNotificationAddedSubscriptionVariables,
} from './SiteNotificationAddedSubscription.generated';

const onSiteNotificationAdded: WorkerSubscription = (args) => {
  const { client, addToQueue, context } = args;
  const variables: SiteNotificationAddedSubscriptionVariables = {
    input: { site: context.site },
  };
  client
    .request({
      variables,
      query: SiteNotificationAddedSubscriptionDocument,
    })
    .subscribe({
      error: console.error,
      next: (value) => {
        const data = value.data as Maybe<SiteNotificationAddedSubscription>;
        const node =
          data?.casinoNotificationSiteNotificationAdded?.addedNotification
            ?.node;
        if (node) {
          addToQueue({ data: node, priority: 'high', type: 'site' });
        }
      },
    });
};

export default onSiteNotificationAdded;
